import type { PreEmploymentEducationStep } from './preEmploymentEducationTypes';

export function stepQuestionKey(stepId: PreEmploymentEducationStep): string {
  return `submitDocuments.preEmploymentEducation.steps.${stepId}`;
}

export const SAFETY_RULE_KEYS = [
  'submitDocuments.preEmploymentEducation.safetyRule1',
  'submitDocuments.preEmploymentEducation.safetyRule2',
  'submitDocuments.preEmploymentEducation.safetyRule3',
  'submitDocuments.preEmploymentEducation.safetyRule4',
  'submitDocuments.preEmploymentEducation.safetyRule5',
] as const;

/** Title + rule list + agree prompt for a single assistant bubble. */
export function safetyRulesBubbleText(t: (key: string) => string): string {
  return [
    t('submitDocuments.preEmploymentEducation.safetyRulesTitle'),
    ...SAFETY_RULE_KEYS.map((key) => t(key)),
    t('submitDocuments.preEmploymentEducation.agreePrompt'),
  ].join('\n');
}
